import { useState, useCallback } from "react";
import { RedactionResult } from "../types/redaction.types";
import { RedactionSummary } from "../types/shared.types";

function b64toBlob(b64Data: string, contentType = "", sliceSize = 512) {
  const byteCharacters = atob(b64Data);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);
    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  const blob = new Blob(byteArrays, { type: contentType });
  return blob;
}

export const useDashboard = () => {
  const [redactionResult, setRedactionResult] =
    useState<RedactionResult | null>(null);
  const [lastJobSummary, setLastJobSummary] = useState<RedactionSummary | null>(
    null
  );
  const [downloadLink, setDownloadLink] = useState<string | null>(null);
  const [refreshTrigger, setRefreshTrigger] = useState<number>(0);

  const handleRedactionComplete = useCallback((result: RedactionResult) => {
    setRedactionResult(result);
    setLastJobSummary(result.summary); // Set summary for the last job

    const blob = b64toBlob(result.file_content, result.mimetype);
    const url = window.URL.createObjectURL(blob);
    setDownloadLink(url);
    setRefreshTrigger((prev) => prev + 1); // Increment trigger to refresh analytics
  }, []);

  const downloadFile = useCallback(() => {
    if (downloadLink) {
      URL.revokeObjectURL(downloadLink);
      setDownloadLink(null);
    }
  }, [downloadLink]);

  return {
    redactionResult,
    lastJobSummary,
    handleRedactionComplete,
    downloadFile,
    downloadLink,
    refreshTrigger,
  };
};
